export default "__VITE_ASSET__zZ9mNdp5__"